import { withTenderTime } from "../../../context/TenderTimeProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "./common.module.scss";
import { File, MapsData, Order, User } from "../../../services";
import OrdersInfoCargo from "./components/OrdersInfoCargo";
import OrdersInfoHeader from "./components/OrdersInfoHeader";
import OrdersInfoBasic from "./components/OrdersInfoBasic";
import OrdersInfoDirections from "./components/OrdersInfoDirections";
import OrdersDriverInfo from "./components/OrdersDriverInfo";
import InfoIcon from "../../shared/icons/InfoIcon";
import UploadFile from "./components/UploadFile";
import Loading from "../../shared/Loading/Loading";
import { toast } from "react-toastify";
import OrderHistory from "./components/OrderHistory";
import SuggestPrice from "./components/SuggestPrice";
import ListSuggestedPrices from "./components/ListSuggestedPrices";
import { useSelector } from "react-redux";
import OrderDecision from "./components/OrderDecision";
import AssignExecutor from "./components/AssignExecutor";
import OrdersInfoAddressList from "./components/OrdersInfoAddressList";
import OrderBookingStatus from "./components/OrderBookingStatus"; // Import the new component
import OrderDecisionClient from "./components/OrderDecisionClient";
import OrdersChatHub from "../../shared/chat/OrdersChatHub";
import OrderAccessRestricted from "./components/OrderAccessRestricted";
import TenderDeadlineInfo from "./components/TenderDeadlineInfo";
import InsuranceStatus from "./components/InsuranceStatus/InsuranceStatus";
import { useLanguage } from "../../../context/LanguageContext";

const OrderInfo = ({
  isOpen,
  setIsOpen,
  orderId,
  companyName,
  onForceUpdate,
  isShowOrderSolution = false,
  tenderOrderInfo,
  isAvailablePage,
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state);
  const company = useSelector((state) => state.user.company);
  const { currentLanguage } = useLanguage();

  const [getOrder, setOrder] = useState(null);
  const [cargoDetails, setCargoDetails] = useState();
  const [recipient, setRecipient] = useState();
  const [bookingDate, setBookingDate] = useState();
  const [statusHistory, setStatusHistory] = useState();
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);
  const [coordinate, setCoordinate] = useState([]);
  const [listDocDriver, setListDocDriver] = useState([]);
  const [driverPhotos, setDriverPhotos] = useState([]);
  const [listSuggestedPrice, setListSuggestedPrice] = useState([]);
  const [driverPrices, setDriverPrices] = useState([]);
  const [orderViews, setOrderViews] = useState([]);
  const [listFilesOrder, setListFilesOrder] = useState([]);
  const [isUploadingAdditional, setIsUploadingAdditional] = useState(false);
  const [additionalFilesQueue, setAdditionalFilesQueue] = useState([]);
  const [unreadMessagesCount, setUnreadMessagesCount] = useState(0);

  const [isLoading, setLoading] = useState(false);
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [isOpenModalHistory, setIsOpenModalHistory] = useState(false);
  const [isOpenChatModal, setIsOpenChatModal] = useState(false);
  const allowedStatusesForDocs = [
    'assigned',
    'assignedexecutor',
    'confirmed',
    'headingtoloading',
    'processloadingcargo',
    'onthetrip',
    'processunloadingcargo',
    'unloadingcargomoderation',
    'completedbyexecutor',
  ];

  const fetchOrderData = async () => {
    if (orderId && isOpen) {
      setLoading(true);
      try {
        const { data } = await Order.getOrderById(orderId, currentLanguage);
        if (data.shippingDate) {
          let date = data.shippingDate.split("T");
          const timeStart =
            data.shippingHourFrom < 10
              ? `0${data.shippingHourFrom}`
              : data.shippingHourFrom;
          const timeEnd =
            data.shippingHourTo < 10 ? `0${data.shippingHourTo}` : data.shippingHourTo;
          data.shippingDate = `${date[0]}T${timeStart}:00:00`;
          data.shippingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        if (data.unloadingDate) {
          let date = data.unloadingDate.split("T");
          const timeStart =
            data.unloadingHourFrom < 10
              ? `0${data.unloadingHourFrom}`
              : data.unloadingHourFrom;
          const timeEnd =
            data.unloadingHourTo < 10 ? `0${data.unloadingHourTo}` : data.unloadingHourTo;
          data.unloadingDate = `${date[0]}T${timeStart}:00:00`;
          data.unloadingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        setOrder(data);
        console.log("[DATA]", data);
      } catch (e) {
        console.log(e);
        toast.error(t('orderInfo.genericError'));
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setIsLoadingMap(true);
    setRouteData(null);
    setListSuggestedPrice([]);
    setDriverPrices([]);
    setUnreadMessagesCount(0);
    setOrderViews([]);

    if (getOrder) {
      const addressList = getOrder.addressList || [];
      const addressListLength = addressList.length || 0;

      if (addressListLength === 2) {
        const loadingAddress = addressList.find(addr => addr.type === 'Loading');
        const unloadingAddress = addressList.find(addr => addr.type === 'Unloading');

        const hasUserAddressIds =
          loadingAddress?.latLng && unloadingAddress?.latLng;

        const routeMethod = hasUserAddressIds
          ? 'getRouteByAddressId'
          : 'getRoute';

        const args = hasUserAddressIds
          ? [loadingAddress.userAddressId, unloadingAddress.userAddressId]
          : [getOrder.cityIdFrom, getOrder.cityIdTo];

        setIsLoadingMap(true);

        MapsData[routeMethod](...args)
          .then((response) => {
            try {
              if (!response?.data?.jsonData) throw new Error('Нет jsonData');
              let parsedData = JSON.parse(response.data.jsonData);

              if (response.data.fromCityId !== getOrder.cityIdFrom) {
                parsedData = parsedData.reverse();
              }

              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } catch (error) {
              console.error('Ошибка при парсинге JSON:', error);
              setRouteData(null);
            } finally {
              setIsLoadingMap(false);
            }
          })
          .catch((error) => {
            console.error(error);
            setIsLoadingMap(false);
            toast.error(t('orderInfo.genericError'));
          });
      } else if (addressListLength > 2) {
        setRouteData(null);
        setIsLoadingMap(false);
      }

      Order.getCargo(getOrder.cargoId)
        .then((response) => {
          if (response.status == 200) {
            setCargoDetails(response.data);
          } else {
            setCargoDetails({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      Order.getRecipient(getOrder.recipientId)
        .then((response) => {
          if (response.status == 200) {
            setRecipient(response.data);
          } else {
            setRecipient({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      User.getHistory(orderId)
        .then((res) => res.data)
        .then((data) => {
          setBookingDate(data[3]?.createdAt);
          setStatusHistory(data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      Order.getCityById(getOrder.cityIdFrom)
        .then((response) => {
          if (response.status == 200) {
            setCityFrom(response.data);
          } else {
            setCityFrom(null);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      Order.getCityById(getOrder.cityIdTo)
        .then((response) => {
          if (response.status == 200) {
            setCityTo(response.data);
          } else {
            setCityTo(null);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      Order.getUnreadMessages(getOrder.id)
        .then((response) => {
          if (response.status === 200) {
            setUnreadMessagesCount(response.data?.count || 0);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      User.getCoordinate(getOrder.number)
        .then((response) => {
          if (response.status == 200) {
            const post = [];
            if (response.data && response.data.length) {
              response.data.map((m) => {
                post.push({
                  lat: m.latitude,
                  lng: m.longitude,
                  date: m.createdAt,
                  type: m.type,
                });
              });
            }
            setCoordinate(post);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      if (getOrder && getOrder.driverId) {
        File.getDocList(getOrder.driverId)
          .then((response) => {
            const filteredData = response.data.filter((doc) => doc.type !== 8);
            const hasTypes = [4, 5, 7].some((type) =>
              filteredData.some((doc) => doc.type === type),
            );

            setListDocDriver(filteredData);

            if (!hasTypes && getOrder.vehicleId) {
              File.getDocListVehicle(getOrder.vehicleId)
                .then((vehicleResponse) => {
                  const combinedData = [...filteredData, ...vehicleResponse.data];
                  setListDocDriver(combinedData);
                })
                .catch((error) => {
                  console.log("Ошибка при получении документов ТС:", error);
                });
            }
          })
          .catch((error) => {
            console.log("Ошибка при получении документов водителя:", error);
          });
      } else if (getOrder && getOrder.vehicleId) {
        File.getDocListVehicle(getOrder.vehicleId)
          .then((vehicleResponse) => {
            setListDocDriver(vehicleResponse.data);
          })
          .catch((error) => {
            console.log("Ошибка при получении документов ТС:", error);
          });
      } else {
        console.log("Невозможно получить документы: ID водителя и ТС не определены");
        setListDocDriver([]);
      }

      File.getOrderDocsDriverPhotos(getOrder.id)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            setDriverPhotos(response.data);
          }
        })
        .catch((error) => {
          console.log("error order docs", error);
        });

      if (user.type === "Client" || getOrder.companyId === company.id) {
        Order.getListSuggestedPrice(getOrder.id)
          .then((response) => {
            const allPrices = response?.data?.rows || [];
            const drivers = allPrices.filter((item) => item.userType === "driver");
            const nonDriverPrices = allPrices.filter((item) => item.userType !== "driver");

            setListSuggestedPrice(nonDriverPrices);
            setDriverPrices(drivers);
          })
          .catch((error) => {
            console.log(error);
          })
      }

      if (getOrder.companyId === company.id) {
        Order.getOrderViewById(getOrder.id)
          .then((response) => {
            if (response.status === 200) {
              setOrderViews(response.data);
            } else {
              setOrderViews([]);
            }
          })
          .catch((error) => {
            console.log(error);
            setOrderViews([]);
          });
      }

      Promise.all([
        File.getFilesByOrder(getOrder.id, 5),
        File.getFilesByOrder(getOrder.id, 7)
      ])
        .then(([resp5, resp7]) => {
          const merged = [
            ...(resp5?.data || []),
            ...(resp7?.data || [])
          ].reverse();
          setListFilesOrder(merged);
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('orderInfo.genericError'));
        });

      if (getOrder.companyId !== company.id) {
        Order.createOrderView(getOrder.id)
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [getOrder]);

  useEffect(() => {
    setUnreadMessagesCount(0);
    fetchOrderData();
  }, [orderId]);

  const fetchDocuments = () => {
    if (!getOrder?.id) return;
    Promise.all([
      File.getFilesByOrder(getOrder.id, 5),
      File.getFilesByOrder(getOrder.id, 7)
    ])
      .then(([resp5, resp7]) => {
        const merged = [
          ...(resp5?.data || []),
          ...(resp7?.data || [])
        ].reverse();
        setListFilesOrder(merged);
      })
      .catch((error) => console.log(error));
  };

  const shouldShowOrderDecision = () => {
    if (!getOrder || !isShowOrderSolution || user.type !== "Expeditor") return false;

    const { expeditorId, companyId, status } = getOrder;
    const isCompleted = status === "completedbyexecutor";

    const isCompany = companyId === company.id;
    const isExpeditor = expeditorId === company.id;

    if (expeditorId === null && isCompany) return true;
    if (isExpeditor) return !isCompleted;
    if (isCompany && isCompleted) return true;

    return false;
  };

  return (
    <div className={cn(style.wrapper, { [style.open]: isOpen })}>
      <OrdersInfoHeader
        item={getOrder}
        setIsOpen={setIsOpen}
        onForceUpdate={onForceUpdate}
        orderViews={orderViews}
      />
      {isLoading ? <Loading borderRadius="16px" /> : null}
      
      {user.type === "Expeditor" && getOrder && getOrder.status !== "awaitingoffer" && getOrder.companyId !== company.id && getOrder.expeditorId !== company.id ? (
        <OrderAccessRestricted assignmentMethod={getOrder.assignmentMethod} onClose={() => setIsOpen(false)} />
      ) : (
      <div className={style.orders_content}>
        <OrdersInfoBasic
          item={getOrder}
          onOpen={() => setIsOpenModalHistory(true)}
          onOpenChat={() => setIsOpenChatModal(true)}
          unreadCount={unreadMessagesCount}
        />
        {isOpenModalHistory && (
          <OrderHistory
            item={getOrder}
            isOpen={isOpenModalHistory}
            statusHistory={statusHistory}
            onClose={() => setIsOpenModalHistory(false)}
            senderName={companyName}
            recipientName={recipient?.name}
            cargoDetails={cargoDetails}
            cityFrom={cityFrom}
            cityTo={cityTo}
            routeData={routeData}
            isLoadingMap={isLoadingMap}
            routeStartCity={routeStartCity}
            coordinateTruck={coordinate}
            bookingDate={bookingDate}
            driverPhotos={driverPhotos}
            listDocDriver={listDocDriver}
            listFilesOrder={listFilesOrder}
            refreshDocuments={fetchDocuments}
          />
        )}

        {isOpenChatModal && getOrder && (
          <OrdersChatHub
            isOpen={isOpenChatModal}
            orderData={getOrder}
            orderId={getOrder.id}
            orderNumber={getOrder.number}
            onClose={() => setIsOpenChatModal(false)}
          />
        )}

        {getOrder && user.type === "Client" && (
          <OrderBookingStatus
            order={getOrder}
            user={user}
            onUpdateData={onForceUpdate}
            fetchOrderData={fetchOrderData}
          />
        )}

        {getOrder && user.type === "Expeditor" && getOrder.companyId === company.id && (
          <OrderBookingStatus
            order={getOrder}
            user={user}
            onUpdateData={onForceUpdate}
            fetchOrderData={fetchOrderData}
          />
        )}

        {getOrder && getOrder.addressList.length < 1 ? (
          <OrdersInfoDirections
            item={getOrder}
            senderName={companyName}
            recipientName={recipient?.name}
          />
        ) : (
          <OrdersInfoAddressList
            order={getOrder}
            addressList={getOrder?.addressList}
          />
        )}

        {user.type === "Client" && getOrder && (
          (getOrder.isPublic && !getOrder.expeditorId && getOrder.status === "unloadingcargomoderation") ||
          (getOrder.isPublic && getOrder.expeditorId && getOrder.status === "completedbyexecutor") ||
          (!getOrder.isPublic && getOrder.expeditorId && getOrder.status === "completedbyexecutor")
        ) && (
          <OrderDecisionClient
            item={getOrder}
            onUpdateData={() => onForceUpdate()}
            fetchOrderData={fetchOrderData}
          />
        )}

        {shouldShowOrderDecision() && (
          <OrderDecision
            item={getOrder}
            onUpdateData={() => onForceUpdate()}
            fetchOrderData={fetchOrderData}
          />
        )}

        {user?.type === "Client" &&
          (user?.companyId === "686becf5e5695daae65de088" || user?.companyId === "69d894b7612386ae6f558c17") &&
          getOrder?.insuranceIncluded && (
            <InsuranceStatus orderId={getOrder.id} userType={user.type.toLowerCase()} />
          )}

        {getOrder && getOrder.companyId === company.id && listSuggestedPrice && listSuggestedPrice.length > 0 && (
          <ListSuggestedPrices
            items={listSuggestedPrice || []}
            fetchOrderData={fetchOrderData}
            isExpeditor={getOrder?.expeditorId}
            ordersStatus={getOrder?.status}
            onUpdateData={() => onForceUpdate()}
            isPublic={getOrder?.isPublic ? getOrder?.isPublic : false}
            user={user}
            tenderDateEnd={getOrder?.tenderDateEnd}
            cargoDetails={cargoDetails}
          />
        )}
        {getOrder && getOrder.companyId === company.id && driverPrices && driverPrices.length > 0 && (
          <ListSuggestedPrices
            items={driverPrices || []}
            fetchOrderData={fetchOrderData}
            isExpeditor={getOrder?.expeditorId}
            ordersStatus={getOrder?.status}
            onUpdateData={() => onForceUpdate()}
            user={user}
            tenderDateEnd={getOrder?.tenderDateEnd}
            cargoDetails={cargoDetails}
            isMarketSuggested
            orderData={getOrder}
            isDriverSuggested
          />
        )}

        {getOrder &&
          getOrder.status === "awaitingoffer" &&
          user?.type === "Client" &&
          getOrder?.tenderDateEnd &&
          listSuggestedPrice.length === 0 && <TenderDeadlineInfo item={getOrder} />}

        {(isShowOrderSolution &&
          getOrder &&
          getOrder.status === "awaitingoffer" &&
          !getOrder.expeditorId && getOrder.companyId !== company?.id) && (
            <SuggestPrice
              onRefreshOrder={fetchOrderData}
              item={getOrder}
              cargoDetails={cargoDetails}
              onUpdateData={() => onForceUpdate()}
              tenderOrderInfo={tenderOrderInfo || []}
            />
          )}

        {isShowOrderSolution && getOrder && getOrder.expeditorId && getOrder.status === "assignedexecutor" && getOrder.companyId !== company?.id && (
          <AssignExecutor
            user={user}
            orderId={getOrder.id}
            onUpdateData={() => onForceUpdate()}
            fetchOrderData={fetchOrderData}
          />
        )}

        {getOrder && getOrder?.status === "published" && isAvailablePage && (
          <AssignExecutor
            user={user}
            orderId={getOrder?.id}
            onUpdateData={() => onForceUpdate()}
            fetchOrderData={fetchOrderData}
          />
        )}

        {getOrder && (getOrder.drivers?.length > 0 || getOrder.driverId) && (
          <OrdersDriverInfo
            item={getOrder}
            drivers={getOrder.drivers || []}
            driverId={getOrder.driverId}
            recipientName={recipient?.name}
            senderName={companyName}
            bookingDate={bookingDate}
            listDocDriver={listDocDriver}
            onUpdateData={() => onForceUpdate()}
            fetchOrderData={fetchOrderData}
          />
        )}
        {getOrder && allowedStatusesForDocs.includes(getOrder?.status?.toLowerCase()) && (
          <UploadFile
            item={getOrder}
            onUpdateData={() => onForceUpdate()}
            fetchOrderData={fetchOrderData}
          />
        )}
        <OrdersInfoCargo item={cargoDetails} order={getOrder} />
        <span className={style.orders_author}>
          <InfoIcon /> {getOrder?.author} {getOrder?.createdAtStr}
        </span>
      </div>
      )}
    </div>
  );
};

export default withTenderTime(OrderInfo);
